module.exports = __webpack_public_path__ + "img/Spinnennetz.912e0ec2.svg";